/**
 * contractsAllApi — UNION list local_p + consignment_p (NPE).
 * Sprint 1: chỉ list. Filter q + paging.
 */
import { baseApi } from './baseApi'
import type { ContractAllItem, ContractAllListQuery, PageResponse } from '@/types/api'

export const contractsAllApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    listAllContracts: b.query<PageResponse<ContractAllItem>, ContractAllListQuery | void>({
      query: (params) => ({ url: '/purchase/contracts/all/list', params: params ?? {} }),
      providesTags: (res) =>
        res
          ? [
              ...res.items.map((it) => ({ type: 'ContractAll' as const, id: it.contract_no })),
              { type: 'ContractAll' as const, id: 'LIST' },
            ]
          : [{ type: 'ContractAll' as const, id: 'LIST' }],
    }),
  }),
})

export const { useListAllContractsQuery } = contractsAllApi
